import Vue from 'vue'
import { localizedPercentage } from 'util/localization-utils'

import withRender from './dim-distribution.html'
import './summary-dim.scss'
import './dim-distribution.scss'

export default withRender(Vue.extend({
  data() { return { dotSize: 0 } },
  props: {
    headingLevel: { type: Number, default: 2 },
    label: String,
    showMiddleLabel: {
      type: Boolean,
      default: true
    },
    values: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    barWidth() {
      return this.numValues > 0 ? (75.0 / this.numValues) : 0
    },
    items() {
      return this.values.map((v) => {
        const totalReviews = this.values.reduce((sum, b) => sum + b.count, 0)
        const lp = localizedPercentage((v.count / totalReviews), 0)
        return {
          desc: this.$msg('dimTeaser.dist.item.desc', [this.label, v.label, lp]),
          height: `${Math.round(v.count / this.maxCount * 100)}%`,
          isMax: this.maxCount === v.count,
          value: lp
        }
      })
    },
    numValues() {
      return this.values.length
    },
    maxCount() {
      return this.values.reduce((acc, v) => v.count > acc ? v.count : acc, 0)
    },
    valueLabels() {
      return this.values.filter((def, i) => {
        // if first or last label
        if (i === 0 || i === this.numValues - 1) {
          return true
        } else if (this.showMiddleLabel && i === (this.numValues === 3 ? 1 : 2)) {
          // middle label is index 1 if there are 3, index 2 if there are 5
          return true
        }
        return false
      }).map(def => def.label)
    }
  }
}))
